import React from "react";
import TableView from "./TableView";
import "./Pictures.css";
import { useTranslation } from "react-i18next";

function Pictures() {
  const { t } = useTranslation();

  return (
    <div className="pictures">
      <div className="pictures-text-head">
        <h2>
         {t('See Success in Action:')}
          <br /> {t("A Glimpse into M-Squared's Vibrant World")}
        </h2>
      </div>
      <div className="pictures-text-para">
        <p>
          {t("Step into the vibrant world of M-Squared Training Center,")}
          {t("where learning takes flight and dreams take shape!")}
        </p>
      </div>
      <TableView/>
    </div>
  );
}

export default Pictures;
